/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Mic_TitleInputs */

const en_us2_coach_mic_title = /** @type {(inputs: Coach_Mic_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tap to transcribe · hold to record and send`)
};

const pt_br2_coach_mic_title = /** @type {(inputs: Coach_Mic_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toque para transcrever · segure para gravar e enviar`)
};

const es_419_coach_mic_title = /** @type {(inputs: Coach_Mic_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toca para transcribir · mantén presionado para grabar y enviar`)
};

const pt_pt2_coach_mic_title = /** @type {(inputs: Coach_Mic_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toca para transcrever · mantém premido para gravar e enviar`)
};

const fr_fr2_coach_mic_title = /** @type {(inputs: Coach_Mic_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Touche pour transcrire · maintiens pour enregistrer et envoyer`)
};

const de_de2_coach_mic_title = /** @type {(inputs: Coach_Mic_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tippen zum Umwandeln · halten zum Aufnehmen und Senden`)
};

const it_it2_coach_mic_title = /** @type {(inputs: Coach_Mic_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tocca per trascrivere · tieni premuto per registrare e inviare`)
};

/**
* | output |
* | --- |
* | "Tap to transcribe · hold to record and send" |
*
* @param {Coach_Mic_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_mic_title = /** @type {((inputs?: Coach_Mic_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Mic_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_mic_title(inputs)
	if (locale === "es-419") return es_419_coach_mic_title(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_mic_title(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_mic_title(inputs)
	if (locale === "de-DE") return de_de2_coach_mic_title(inputs)
	if (locale === "it-IT") return it_it2_coach_mic_title(inputs)
	return en_us2_coach_mic_title(inputs)
});
export { coach_mic_title as "coach-mic.title" }